<template>
  <div class="tabs-wrapper tabs-wrapper-screen">
    <Button
      class="tabs-item"
      type="icon"
      v-for="(item, index) in tabsList"
      :key="index"
      @click="handleTabs(item)"
    >
      <span
        class="tabs-icon-text"
      >
          {{ tabsDic[item-1] }}
      </span>
      <i
        :class="[
          'tabs-icon-def',
          item === Number(currentIndex) ? 'tabs-icon-selected' : ''
        ]"
      />
    </Button>
  </div>
</template>

<script>
import Button from '../Button.vue';

export default {
  name: 'tabs',

  components: {
    Button,
  },

  data() {
    return {
      tabsDic: ['编码探险(基础)', '编码探险(提升)', '编码探险(突破)', '编码进阶', '香蕉传奇', '河狸梦想家'],
      currentIndex: null,
    };
  },

  props: {
    tabsList: {
      type: Array,
      default: () => [1, 2, 3, 4, 5, 6],
    },
  },

  methods: {
    handleTabs(tabId) {
      this.currentIndex = tabId;
      this.$router.push({
        path: '/cmlist',
        query: {
          ...this.$route.query,
          ctId: tabId,
        },
      });
      this.$emit('changeTabs', tabId);
    },
  },

  created() {
    const { ctId = '1' } = this.$route.query;
    this.currentIndex = ctId;
  },
};
</script>

<style lang='less' scoped>
@import '../../assets/styles/font.less';

.tabs-wrapper {
  width: 100%;
  height: 45px;
  padding-left: 100px;

  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;

  .tabs-item {
    font-family: 'fzsq';
    width: 130px;
    height: 44px;
    margin-right: 7px;
  }
}
</style>
